import PropTypes from 'prop-types';
import React from 'react';
import ButtonComponent from '../component/global/Button';
import ButtonDropdownComponent from '../component/global/ButtonDropdown';
import ButtonGroupComponent from '../component/global/ButtonGroup';
import ItemList from '../component/global/ItemList';
import ItemListHeaderComponent from '../component/global/ItemListHeader';
import ItemListMenuComponent from '../component/global/ItemListMenu';
import LabelsComponent from '../component/global/Labels';
import PageHeaderComponent from '../component/global/PageHeader';
import PeopleComponent from '../component/global/People';
import TitleComponent from '../component/global/Title';
import TotalComponent from '../component/global/Total';

const Contacts = ({ icon, pageTitle, scope, data, prop, updated }) => {
  const header = (
    orderBy,
    isDescending,
    getOrderAndDirection,
    getIsOrdered,
    toggleBulkActions,
    countOfSelectedItems,
    shown,
    disableOrderAndDirection
  ) => (
    <ItemListHeaderComponent
      eventId="contactsListHeaderSort"
      toggleBulkActions={toggleBulkActions}
      getOrderAndDirection={getOrderAndDirection}
      getIsOrdered={getIsOrdered}
      isDescending={isDescending}
      disableOrderAndDirection={disableOrderAndDirection}
      columns={[
        { id: 'name', coerce: 'string', title: 'Name', isDefault: true },
        { id: 'phone', coerce: 'number', title: 'Phone' },
        { id: 'email', coerce: 'string', title: 'Email' },
        { id: 'idLabels', coerce: 'string', title: 'Labels' },
        { id: 'idOwner', coerce: 'string', title: 'Owner' }
      ]}>
      <ItemListMenuComponent>
        <TotalComponent
          prefix="Selected"
          shown={countOfSelectedItems}
          size={shown}
          type="Contacts"
        />
        <ButtonComponent
          id="contactsListHeaderLabel"
          icon="icon-tags-edit"
          toolTip="Add label(s)"
        />
        {scope?.Root?.CurrentOrganization?.hasMailChimpIntegration() && (
          <ButtonComponent
            id="contactsListHeaderMailChimp"
            icon="icon-mailchimp"
            toolTip="Add to MailChimp list"
          />
        )}
        {scope?.Root?.CurrentOrganization?.hasCampaignMonitorIntegration() && (
          <ButtonComponent
            id="contactsListHeaderCampaignMonitor"
            icon="icon-campaign-monitor"
            toolTip="Add to CampaignMonitor list"
          />
        )}
        {scope?.Root?.CurrentOrganization?.isCampaignMonitorEmbedEnabled() &&
          scope?.Root?.isCampaignMonitorEnabled() && (
            <ButtonComponent
              id="contactsListHeaderCampaignMonitorEmbed"
              icon="icon-campaign-monitor"
              toolTip="Campaign monitor"
            />
          )}
        <ButtonComponent
          id="contactsListHeaderArchive"
          icon="icon-archive"
          toolTip="Archive contact(s)"
        />
        <ButtonComponent
          id="contactsListHeaderUnarchive"
          icon="icon-archive-drawer"
          toolTip="Un-archive contact(s)"
        />
        <ButtonComponent
          id="contactsListHeaderDelete"
          icon="icon-bin"
          toolTip="Delete contact(s)"
        />
      </ItemListMenuComponent>
    </ItemListHeaderComponent>
  );

  const body = (dataState, item, isSelected) => (
    <dl data-item-selected={isSelected}>
      <dt>
        <TitleComponent avatar={item?.getAvatar()} title={item?.getName()} />
      </dt>
      <dd>{item?.getPhone()}</dd>
      <dd>{item?.getEmail()}</dd>
      <dd>
        <LabelsComponent labels={dataState?.Labels?.getCollectionData()} ids={item?.idLabels} />
      </dd>
      <dd>
        <PeopleComponent
          people={dataState?.Accounts?.getCollectionData()}
          ids={item?.idOwner}
        />
      </dd>
      <ItemListMenuComponent>
        <ButtonComponent
          id="contactsListEdit"
          icon="icon-pencil-2"
          toolTip={`Edit ${item?.getName()}`}
          toolTipPosition="left"
          clickButtonArgs={item}
        />
        <ButtonComponent
          id="contactsListLabel"
          icon="icon-tags-edit"
          toolTip={`Edit label(s) for ${item?.getName()}`}
          toolTipPosition="left"
          clickButtonArgs={item}
        />
        <ButtonComponent
          id="contactsListDuplicate"
          icon="icon-archive-books"
          toolTip={`Duplicate ${item?.getName()}`}
          toolTipPosition="left"
          clickButtonArgs={item}
        />
        {item?.isActive && (
          <ButtonComponent
            id="contactsListArchive"
            icon="icon-archive"
            toolTip={`Archive ${item?.getName()}`}
            toolTipPosition="left"
            clickButtonArgs={item}
          />
        )}
        {!item?.isActive && (
          <ButtonComponent
            id="contactsListUnarchive"
            icon="icon-archive-drawer"
            toolTip={`Un-archive ${item?.getName()}`}
            toolTipPosition="left"
            clickButtonArgs={item}
          />
        )}
        <ButtonComponent
          id="contactsListDelete"
          icon="icon-bin"
          toolTip={`Delete ${item?.getName()}`}
          toolTipPosition="left"
          clickButtonArgs={item}
        />
      </ItemListMenuComponent>
    </dl>
  );

  return (
    <>
      <PageHeaderComponent icon={icon} title={pageTitle}>
        <ButtonGroupComponent>
          <ButtonComponent id="contactsFiltersToggle" title="Filter" icon="icon-filter-1" />
          <ButtonDropdownComponent
            id="contactAddNew"
            title="Add new"
            icon="icon-add-square"
            items={[
              {
                id: 'contactAddNewPerson',
                icon: 'icon-single-neutral-circle',
                title: 'Person',
                clickButtonArgs: { id: '0', type: 'person' }
              },
              {
                id: 'contactAddNewCompany',
                icon: 'icon-building-1',
                title: 'Company',
                clickButtonArgs: { id: '0', type: 'company' }
              }
            ]}
            dropdownPosition="right"
          />
        </ButtonGroupComponent>
      </PageHeaderComponent>
      <ItemList
        data={data}
        prop={prop}
        type={pageTitle}
        header={header}
        body={body}
        updated={updated}
      />
    </>
  );
};

Contacts.propTypes = {
  icon: PropTypes.string.isRequired,
  pageTitle: PropTypes.string.isRequired,
  scope: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  prop: PropTypes.string.isRequired,
  updated: PropTypes.string
};

Contacts.defaultProps = {
  updated: undefined
};

export default Contacts;
